import React, {useEffect, useState} from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, useJsApiLoader, Marker, InfoBox, InfoWindow } from '@react-google-maps/api';
import axios from 'axios';
import useClinics from '../../store/clinics/clinicsContext';
import InfoWindowComponent from './InfoWindow/InfoWindowComponent';
import MarkerIcon from '../../images/MarkerIcons/4.png'
import ReactSelect from '../Inputs/ReactSelect';

require('dotenv').config()

function MapComponent({selectedClinic, setSelectedClinic, setCurrentStep}) {

  const { getAllClinics } = useClinics();

  const googleAPIKey = 'AIzaSyDLXjBpTKT2RS9tS-G_sI3ssb8StSflhF0';

  const [clinics, setClinics] = useState([]);

  const [clinicMarkers, setClinicMarkers] = useState([]);

  const [infoWindow, setInfoWindow] = useState("");

  const [city, setCity] = useState("Brussels")

  const cityOptions = [{
    label: "Brussels",
    value: {
      lat: 50.84904759447118,
      lng: 4.356505611964237
    }
  },
  {
    label: "Ghent",
    value: {
      lat: 51.04687587724761, 
      lng: 3.731015638551353
    }
  },
  {
    label: "Antwerp",
    value: {
      lat: 51.24001653837354,
      lng: 4.400318168140327
    }
  }]

  const [center, setCenter] = useState({
    lat: 50.84904759447118,
    lng: 4.356505611964237
  })

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleAPIKey,
    mapIds: ["40f95724853f25f0"]
  });

  const fetchClinics = () => {
    getAllClinics().then(res => {
      setClinics(res)
    })
  }

  const fetchCoordinates = async (clinic, state) => {
    const address = clinic.location.address;
    const postalCode = clinic.location.postal_code;
    const city = clinic.location.city;
    const country = clinic.location.country;
    const email = clinic.email
    const type = clinic.type;
    const tokenValue = localStorage.getItem('jwtToken');
    delete axios.defaults.headers.common["x-access-token"];  
    const res = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address},${postalCode},${city},${country}&key=${googleAPIKey}`);
    axios.defaults.headers.common["x-access-token"] = tokenValue;
    const data = res.data;
    const latitude = data.results[0].geometry.location.lat;
    const longitude = data.results[0].geometry.location.lng;
    return state.push({id: clinic._id, name: clinic.name, lat: latitude, lng: longitude, address: address, country: country, postalCode: postalCode, city: city, type: type, phone: clinic.phone_nb, email: clinic.email });
  }

  useEffect(() => {
   fetchClinics();
  }, [])
  
  useEffect(() => {
    if (!clinics.length) return;
    (async () => {
      //Intermediary state to keep clinics state
      const stateToUpdate = [];
      for (let clinic of clinics) {
        await fetchCoordinates(clinic, stateToUpdate);
      }
      setClinicMarkers(stateToUpdate)
    })();
  }, [clinics])

  const showInfoWindow = (id) => {
    setInfoWindow(id);
  }

  return (
  <div className="h-full w-full relative">
    {isLoaded ? (
      <GoogleMap  
        mapContainerStyle={{width:'100%', height:"100%"}}
        center={center}
        zoom={12}
        options={{mapId: '40f95724853f25f0'}} 
        onClick={()=>{setInfoWindow("")}}
      >
        <ReactSelect id="city" label="Select city:" inputClass="ml-4 w-60 absolute top-0 right-20" labelClass='pt-2' options={cityOptions} value={city} onChange={(e) => {setCenter(e.value); setCity(e.label);}}/>
        {clinicMarkers.length && clinicMarkers.map(clinic => {
          return <div>
            <Marker key={clinic.id} position={{lat:clinic.lat, lng: clinic.lng}} title={clinic.name} icon={{url: MarkerIcon, scaledSize: new google.maps.Size(65, 65)}} onClick={() => {showInfoWindow(clinic.id)}}>
            
            {infoWindow === clinic.id && 
              <InfoWindow 
                key={clinic.id} 
                options={{ 
                  boxStyle: {
                    boxShadow: `3px 3px 10px rgba(0,0,0,0.6)`,
                    backgroundColor: "black",
                    borderRadius: "0.5rem",
                  },
                  closeBoxURL: ""
                }}
              >
                <InfoWindowComponent key={clinic.id} id={clinic.id} phone={clinic.phone} address={clinic.address} postalCode={clinic.postalCode} city={clinic.city} name={clinic.name} email={clinic.email} type={clinic.type} country={clinic.country} setSelectedClinic={setSelectedClinic} setCurrentStep={setCurrentStep}/>
              </InfoWindow>
            }
            </Marker>
          </div>
        })}
      </GoogleMap>
    ) : (<></>)}
  </div>
  )
}

export default MapComponent;